import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { AiOutlineWarning } from "react-icons/ai";

const ConfirmDeleteModal = ({ show, onHide, onConfirm, user, deleting }) => {
  const [input, setInput] = useState("");
  const [matched, setMatched] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (!show) {
      setInput("");
      setMatched(false);
      setShowError(false);
    }
  }, [show]);

  const checkMatch = () => {
    if (!user) return false;
    const val = (input || "").trim().toLowerCase();
    const email = (user.email || "").toString().toLowerCase();
    const username = (user.username || "").toString().toLowerCase();
    const fullName = (user.full_name || user.fullName || "").toString().toLowerCase();
    return val === email || val === username || val === fullName;
  };

  useEffect(() => {
    setMatched(checkMatch());
  }, [input, user]);

  const handleConfirm = () => {
    if (!checkMatch()) {
      setShowError(true);
      return;
    }
    onConfirm();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      contentClassName="rounded-3 shadow-lg border-0"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="d-flex align-items-center gap-2 text-danger fw-bold">
          <AiOutlineWarning size={22} /> Confirm account deletion
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 pb-4">
        <p className="mb-3 text-gray-400">
          This action is irreversible. To confirm deletion, type your <strong>email</strong> or <strong>username</strong> below and press
          <strong> Confirm</strong>.
        </p>

        <Form.Group>
          <Form.Control
            type="text"
            placeholder="Type your email or username"
            value={input}
            onChange={(e) => {
              setInput(e.target.value);
              setShowError(false);
            }}
          />
        </Form.Group>

        {showError && (
          <div className="text-danger small mt-2">Input does not match your email or username.</div>
        )}

        <div className="gap-2 d-flex align-items-center justify-content-center mt-3">
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button className="red-btn" onClick={handleConfirm} disabled={!matched || deleting}>
            {deleting ? "Deleting..." : "Confirm"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmDeleteModal;
